export * from '@white-label-store/modal-data';
